import { AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { AuthService } from '@teem/app/core/services/auth.service';
import { StoreInformationService } from '@teem/app/core/services/store-information.service';
import { debounceTime, map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProfileService } from '@teem/app/core/services/profile.service';

export function uniqueEmailValidator(authService: AuthService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(email =>
        authService.checkEmail(email).pipe(
          map((res: any) => (res?.is_exist ? { emailTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}

export function uniquePhoneValidator(authService: AuthService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(phone =>
        authService.checkPhone(phone).pipe(
          map((res: any) => (res?.is_exist ? { phoneTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}

export function uniqueSlugValidator(storeInformationService: StoreInformationService, type: string): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(slug =>
        storeInformationService.checkSlug({'slug': slug, 'type': type}).pipe(
          map((res: any) => (res?.is_exist ? { slugTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}

export function uniqueBranchSlugValidator(storeInformationService: StoreInformationService, id: string): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(slug =>
        storeInformationService.checkBranchSlug({'slug': slug, 'id': id}).pipe(
          map((res: any) => (res?.is_exist ? { slugTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}

export function uniqueCustomerEmailValidator(profileService: ProfileService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(email =>
        profileService.checkEmail(email).pipe(
          map((res: any) => (res?.is_exist ? { emailTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}

export function uniqueCustomerPhoneValidator(profileService: ProfileService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return of(null); // Return null if no value entered

    return of(control.value).pipe(
      debounceTime(300), // Add debounce to avoid excessive API calls
      switchMap(phone =>
        profileService.checkPhone(phone).pipe(
          map((res: any) => (res?.is_exist ? { phoneTaken: true } : null)),
          catchError(() => of(null)) // Handle errors gracefully
        )
      )
    );
  };
}